{"reorderNotAvailable":"⚠️ Backend hiện chưa hỗ trợ sắp xếp lại thứ tự ảnh. Thay đổi này chỉ hiển thị tạm thời"}